import { getRouteMapList } from '@/apis/miniProgram/routeMap'
const baseRouteMap = [
  {
    // 医院列表
    mp: '/subPackages/appointment/hospital/list',
    h5: '/registration_hospital_list',
  },
  {
    // 院区列表
    mp: '/subPackages/appointment/hospital/area',
    h5: '/registration_hospital_area_news',
  },
  {
    // 医院主页
    mp: '/subPackages/appointment/hospital/detail',
    h5: '/PCregistration_hospital_detail_new',
  },
  {
    // 快速挂号
    mp: '/subPackages/fast-appointment/index/index',
    h5: '/registration_fast_appointment',
  },
  {
    // 快速检查
    mp: '/subPackages/fast-appointment/examination/index',
    h5: '/quickExamination',
  },
  {
    // 快速检查分类
    mp: '/subPackages/fast-appointment/examination/category',
    h5: '/quickExamination/category',
  },
  {
    // 快速检查门诊检验检查开单
    mp: '/subPackages/fast-appointment/examination/billing',
    h5: '/quickExamination/billing',
  },
  {
    // 快速检查专家预约
    mp: '/subPackages/fast-appointment/examination/expert',
    h5: '/quickExamination/expert',
  },
  {
    // 快速检查购物车
    mp: '/subPackages/fast-appointment/examination/cart',
    h5: '/quickExamination/cart',
  },
  {
    // 快速检查确认订单
    mp: '/subPackages/fast-appointment/examination/orderConfirm',
    h5: '/quickExamination/orderConfirm',
  },
  {
    // 快速检查订单详情
    mp: '/subPackages/fast-appointment/examination/orderDetail',
    h5: '/quickExamination/orderDetail',
  },
  {
    // 快速检查订单列表
    mp: '/subPackages/fast-appointment/examination/orderList',
    h5: '/quickExamination/orderList',
  },
  {
    // 快速检查订单退款
    mp: '/subPackages/fast-appointment/examination/refund',
    h5: '/quickExamination/refund',
  },
  {
    // 科室列表页
    mp: '/subPackages/appointment/department/department',
    h5: '/registration_depart_list_new',
  },
  {
    // 科室搜索页
    mp: '/subPackages/appointment/department/search',
    h5: '/registration_dep_search',
  },
  {
    // 医生列表页
    mp: '/subPackages/appointment/doctor/list',
    h5: '/registration_doctor_list_new',
  },
  {
    // 医生详情页
    mp: '/subPackages/appointment/doctor/detail',
    h5: '/registration_doctor_detail_new',
  },
  {
    // 挂号订单确认页
    mp: '/subPackages/appointment/order/confirm',
    h5: '/registration_order_confirm_new',
  },
  {
    // 挂号订单详情页
    mp: '/subPackages/appointment/order/detail',
    h5: '/ucenter_appointment_order_details',
  },
  {
    // 挂号订单列表页
    mp: '/subPackages/appointment/order/list',
    h5: '/ucenter_register_records_new',
  },
]
let state = {
  routeMap: []
}
const actions = {
  async initRouteMap({ commit}) {
    let result = baseRouteMap;
    try {
      const res = await getRouteMapList()
      result = (res.data || []).filter(item => item.status === 0).map(item => {
        return {
          mp: item.mp,
          h5: item.h5
        }
      })
    } catch (error) {
      console.log(error)
    }
    commit('INIT_ROUTE_MAP', result)
  }
}
const mutations = {
  INIT_ROUTE_MAP(state, routeMap) {
    state.routeMap = routeMap
  }
}
const getters = {
  getRouteMap(state) {
    return state.routeMap
  }
}
export default {
  state,
  mutations,
  actions,
  getters
}
